import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => (
  <div className="min-h-[80vh] flex flex-col items-center justify-center bg-gray-50">
    <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
    <h2 className="text-2xl font-semibold text-gray-800 mb-2">
      Página no encontrada
    </h2>
    <p className="text-gray-500 mb-8">
      La ruta que buscas no existe o ha sido movida.
    </p>
    <Link
      to="/"
      className="px-6 py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition"
    >
      Ir al inicio
    </Link>
  </div>
);

export default NotFound;
